module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "warning",
      "dismissible": "true",
      "value": _vm.$route.query.error !== undefined
    }
  }, [_vm._v("\n    SSO error: " + _vm._s(_vm.$route.query.error) + "\n  ")]), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "offset-md": "4",
      "sm": "6",
      "offset-sm": "3"
    }
  }, [_c('img', {
    staticClass: "my-5",
    staticStyle: {
      "width": "75%",
      "display": "block",
      "margin-right": "auto",
      "margin-left": "auto"
    },
    attrs: {
      "src": 'static/logo.png'
    }
  }), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Login")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Email",
      "id": "email",
      "required": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login()
      }
    },
    model: {
      value: (_vm.credentials.username),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "username", $$v)
      },
      expression: "credentials.username"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Password",
      "id": "password",
      "type": _vm.pwdVisibility ? 'text' : 'password',
      "required": "",
      "append-icon": _vm.pwdVisibility ? 'mdi-eye' : 'mdi-eye-off'
    },
    on: {
      "click:append": function($event) {
        _vm.pwdVisibility = !_vm.pwdVisibility
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login()
      }
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "password", $$v)
      },
      expression: "credentials.password"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'passwordResetRequest'
      }
    }
  }, [_vm._v("Forgot My Password")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_vm._v("Login")])], 1)], 1), _vm._v(" "), (_vm.oktaAvailable) ? _c('v-card', {
    staticClass: "text-with-lines my-1",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "text-content"
  }, [_vm._v("\n          OR\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.oktaAvailable) ? _c('v-btn', {
    staticStyle: {
      "display": "block",
      "margin-right": "auto",
      "margin-left": "auto"
    },
    attrs: {
      "outlined": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.oktaLogin.apply(null, arguments)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "15%",
      "margin-right": "5%"
    },
    attrs: {
      "src": "static/okta.png"
    }
  }), _vm._v("\n        Login with Okta\n      ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('error-snackbar', {
    model: {
      value: (_vm.errorText),
      callback: function($$v) {
        _vm.errorText = $$v
      },
      expression: "errorText"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-034b536d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 410
// module chunks = 1